var $ = require("jquery");

$(document).ready(function() {
  $(".modal__close, .modal--location .modal__button").on("click", function() {
    var $modal = $(this).closest("section.modal");

    $modal.removeClass("modal--is-visible");
  });

  $(
    '.single-education .sidebox .button--primary:not([href*="education_id"]), .single-education .sidebox-tabs .button--primary:not([href*="education_id"]), .single-education .button-row .button--icon-cta:not([href*="education_id"]), a[href="#open-modal"]'
  ).on("click", function(e) {
    e.preventDefault();

    if (e.currentTarget.className.includes("custom-sign-up-link")) {
      window.open(e.currentTarget.href, "_blank");
      return;
    }

    var $modal = $(".modal");

    $modal.addClass("modal--is-visible");
  });
});
